import { createFileRoute, redirect } from '@tanstack/react-router'
import { ContractDocumentEditorPage } from '@/features/contract/index.ts'

export const Route = createFileRoute('/_authenticated/contracts/edit/$documentId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.documentId)) || Number(params.documentId) < 1) {
      throw redirect({ to: '/contracts/documents', search: { current: 1, pageSize: 20 }, replace: true })
    }
  },
  head: () => ({ meta: [{ title: '编辑合同文件 · Super Mega' }] }),
  component: Page
})

function Page() {
  const { documentId } = Route.useParams()
  return <ContractDocumentEditorPage key={documentId} documentId={Number(documentId)} />
}
